import React from "react";

const SubRentalWarning = () => {
    return (
        <div className="col-12 mt-3">
            <p className="text-red-600">
                <span className="highlight-message">
                    <span className="warning-icon">⚠️</span>For sub-rental size changes, please contact DuBois at (800) 236-7303.
                </span>
            </p>
        </div>
    );
};

export default SubRentalWarning;
